import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FormularioPaso3 from "../subcribirseForm/FormularioPaso3";
import { TokenPayload, FormData1, PaymentOption } from "@/types";
import { jwtDecode } from "jwt-decode";
import { safeFetch } from "@/api/safeFetch";

function Renovar() {
  const { perfil_profesional_id, profesional_id } = useParams<{
    perfil_profesional_id: string;
    profesional_id: string;
  }>();
  

  const [formData1, setFormData1] = useState<FormData1>({
    perfil_profesional_id: 0,
    profesional_id: 0,
    usuario_id: 0,
    selectedProfesion: [],
    fechaFinSeleccionada: new Date().toISOString().split('T')[0], // ✅ ISO string
  });

  const [paymentOption, setPaymentOption] = useState<PaymentOption>("Anual");
  const [paymentAmount, setPaymentAmount] = useState<number>(240);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // 🔐 Obtener usuario_id del token
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const decoded = jwtDecode<TokenPayload>(token);
      if (decoded.usuario_id) {
        setFormData1((prev) => ({ ...prev, usuario_id: decoded.usuario_id }));
      }
    } catch (err) {
      console.error("Error decodificando token:", err);
    }
  }, []);

  // 📦 Cargar perfil profesional
  useEffect(() => {
    const fetchPerfil = async () => {
      if (!perfil_profesional_id || !profesional_id) return;

      try {
        setIsLoading(true);

        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token no encontrado");

        const res = await safeFetch(
          `/api/perfiles-profesionales/${perfil_profesional_id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (!res.ok) throw new Error("Error al obtener el perfil profesional");

        const data = await res.json();

        setFormData1({
          perfil_profesional_id: data.perfil_profesional_id,
          profesional_id: data.profesional_id,
          usuario_id: data.usuario_id,
          nombre: data.nombre || "",
          apellidos: data.apellidos || "",
          email: data.email || "",
          numero_telefono: data.numero_telefono || "",
          idSelectDniNie: data.nie ? "nie" : "dni",
          dniNie: data.nie || data.dni || "",
          calle: data.calle || "",
          locality: data.localidad || "",
          province: data.provincia || "",
          postalCode: data.codigo_postal || "",
          pais: data.pais || "",
          nombre_empresa: data.nombre_empresa || "",
          cif: data.cif || "",
          nombre_profesion: data.profesion_nombre || "",
          selectedProfesion: data.profesion_nombre
            ? [data.profesion_nombre]
            : [],
          fechaFinSeleccionada: data.fechaFinSeleccionada
            ? new Date(data.fechaFinSeleccionada).toISOString().split('T')[0] // ✅ convertir a ISO
            : new Date().toISOString().split('T')[0],
        });

        setPaymentOption(data.paymentOption ?? "Anual");
        setPaymentAmount(data.paymentAmount ?? 240);
      } catch (err: any) {
        console.error(err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPerfil();
  }, [perfil_profesional_id, profesional_id]);

  if (isLoading)
    return <div className="text-center mt-8">Cargando datos...</div>;

  if (error)
    return (
      <div className="text-center text-red-500 mt-8">
        ❌ {error}
      </div>
    );

  return (
    <div className="mt-6 rounded-2xl shadow-lg shadow-zinc-600 border border-black border-b-2 border-r-8 bg-white px-6 py-8 w-full max-w-6xl">
      <FormularioPaso3
        formData1={formData1}
        setFormData1={setFormData1}
        paymentAmount={paymentAmount}
        setPaymentAmount={setPaymentAmount}
        paymentOption={paymentOption}
        setPaymentOption={setPaymentOption}
        onPaymentChange={(option: PaymentOption, amount: number) => {
          setPaymentOption(option);
          setPaymentAmount(amount);
        }}
        selectedProfesiones={formData1.selectedProfesion || []}
        isEmpresa={!!formData1.nombre_empresa || !!formData1.cif}
        modoRenovar={true}
        isFirmaAccepted={true}
      />
    </div>
  );
}

export default Renovar;